module.exports = __webpack_public_path__ + "assets/img/droped.277fc8cc.svg";